export enum PuiButtonType {
  Icon = <any>'icon',
  Link = <any>'link',
  Normal = <any>'default',
  Submit = <any>'submit',
  Portlet = <any>'portlet',
  Primary = <any>'primary'
};
